import { Fragment } from 'react';
import { Flex } from './TremorCompat';
import { Panel } from 'rsuite';

import { DisplayIcon } from './DisplayIcon';

const addLineBreak = (str) =>
  str.split('\n').map((subStr, index) => {
    return (
      <Fragment key={index}>
        {subStr}
        <br />
      </Fragment>
    );
  });

export const DisplayListAccordian = ({ register, icon, borderOff }) => {
  const getNewLInes = (value) => {
    var theString = '';
    if (value) {
      theString = value.replaceAll('|', '\n');
    }
    return addLineBreak(theString);
  };

  return (
    <Panel bordered={!borderOff} style={{ backgroundColor: 'white' }}>
      <Flex justifyContent="start" className="space-x-2">
        <DisplayIcon icon={icon} />
        <Panel collapsible bordered header={register.title}>
          {getNewLInes(register.display)}
        </Panel>
      </Flex>
    </Panel>
  );
};
